<template>
  <div class="wwd">
    <div class="container">
      <div class="content-box">
        <div class="left">
          <left-tab :title="tabName" className="top0"></left-tab>
          <div class="text">
            {{ des }}
          </div>
          <!-- <div class="white-box" @click="$router.push('/capabilities')">
            learn more
          </div> -->
          <div class="white-box">
            <button2 path="/capabilities" :text="buttonText"></button2>
          </div>
        </div>
        <div class="right">
          <img src="@/assets/images/home/img_1.png" alt="" />
        </div>
      </div>
      <div class="do-list">
        <div
          class="do-item"
          v-for="item in dolist"
          :key="item.id"
          @click="$router.push(item.path)"
        >
          <div class="icon-box">
            <svg-icon :iconClass="item.iconClass"></svg-icon>
          </div>
          <div class="title">
            {{ item.title }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import leftTab from "@/components/leftTab/index.vue";
import button2 from "@/components/cmrbutton/type2.vue";
import { getItem } from "@/utils/localStorage";
export default {
  components: {
    leftTab,
    button2,
  },
  data() {
    return {
      dolist: [],
      tabName: "",
      des: "",
      buttonText: "",
    };
  },
  mounted() {
    if (getItem("language") == "zh-cn") {
      this.dolist = [
        {
          id: "0",
          title: "设计与工程",
          path: { path: "/capabilities", query: { md: "capa-design" } },
          iconClass:"home-design"
        },
        {
          id: "1",
          title: "精密制造",
          path: { path: "/capabilities", query: { md: "capa-pecision" } },
          iconClass:"home-precious"
        },
        {
          id: "2",
          title: "自动化",
          path: { path: "/capabilities", query: { md: "capa-automation" } },
          iconClass:"home-auto"
        },
        {
          id: "3",
          title: "质量管理",
          path: { path: "/capabilities", query: { md: "capa-quality" } },
          iconClass:"home-qu"
        },
      ];
      this.buttonText = "了解更多";
      this.tabName = "我们的能力";
      this.des =
        "斯莫尔提供从早期模型设计到迭代开发的全方位服务解决方案。我们的创新能力为客户提供了各种可能的选择，使客户的想法成功转化为产品发布。";
    } else {
      this.dolist = [
        {
          id: "0",
          title: "Design & Engineering",
          path: { path: "/capabilities", query: { md: "capa-design" } },
          iconClass:"home-design"
        },
        {
          id: "1",
          title: "Precision Manufacturing",
          iconClass:"home-precious",
          path: { path: "/capabilities", query: { md: "capa-pecision" } },
        },
        {
          id: "2",
          title: "Automation",
          path: { path: "/capabilities", query: { md: "capa-automation" } },
          iconClass:"home-auto"
        },
        {
          id: "3",
          title: "Quality Assurance",
          path: { path: "/capabilities", query: { md: "capa-quality" } },
          iconClass:"home-qu"
        },
      ];
      this.tabName = "What We Do";
      this.buttonText = "Learn More";
      this.des =
        "CMR offers a diverse range of full-service solutions, from early-stage prototyping to iterative development. Our innovative capabilities provide our customers all possible options to transform their ideas into successful product launches.";
    }
  },
};
</script>

<style lang="less" scoped>
.wwd {
  padding: 1.2rem 0 0rem;
  .container {
    padding: 0 2.6rem;
    .content-box {
      display: flex;
      justify-content: space-between;
      // align-items: center;
      .left {
        width: 5.8rem;
        .white-box {
          // line-height: 0.5rem;
          margin-top: 0.6rem;
          // text-align: center;
          // width: 3.7807rem;
          // height: 0.6325rem;
          // line-height: 0.6325rem;
          // background-color: #fff;
          // box-shadow: 2px 2px 2px 1px rgb(217, 217, 217);
          // transition: all 0.5s;
          // &:hover {
          //   transform: scale(1.1);
          //   cursor: pointer;
          // }
        }
      }
      .right {
        img {
          width: 8rem;
        }
      }
    }
    .do-list {
      margin-top: 1rem;
      display: flex;
      justify-content: space-between;
      .do-item {
        width: 3.2rem;
        .icon-box {
          text-align: center;
          font-size: 0.8rem;
        }

        .title {
          text-align: center;
          font-weight: 700;
        }
        &:hover {
          cursor: pointer;
          .title {
            color: #b94060;
          }
        }
      }
    }
  }
}
@media screen and (max-width: 760px) {
  .wwd {
    box-sizing: border-box;
    padding: 0 0;
    .container {
      box-sizing: border-box;
      padding: 0 0.3rem;
      margin-top: 0.9rem;
      .content-box {
        display: block;

        .left {
          width: 100%;
          .text {
            padding: 0 0;
            word-break: break-all;
          }
          .white-box {
            // width: 4rem;
            // height: 1rem;
            // line-height: 1rem;
            // margin-left: auto;
            // background-color: rgb(228, 85, 85);
            margin-top: 0.6rem;
            margin-bottom: 0.6rem;
          }
        }
        .right {
          img {
            width: 100%;
          }
        }
      }
      .do-list {
        margin-top: 0.2rem;
        flex-wrap: wrap;
        .do-item {
          width: 50%;
          margin-top: 0.3rem;
          .icon-box {
            font-size: 1rem;
          }
          .title {
            margin-top: 0.1rem;
          }
        }
      }
    }
  }
}
</style>
